export default __webpack_public_path__ + "static/media/chevron_leftFasting.176ef9f7.svg";